import React from 'react'
import {
  Layout,
  GlobalStyle,
  sKanava,
  Footer,
  PlaceOfBusinessInfo,
  media,
  RestrictedWidthContainer,
  setCurrentLanguage,
  AnimationWrapper,
  SBonus,
  SBonusDisplay,
} from '@sok-brand-sites/common-frontend-components'
import { useStaticQuery, graphql } from 'gatsby'
import styled, { ThemeProvider } from 'styled-components'
import '@sok-brand-sites/common-frontend-components/dist/gutenberg.css'
import helpers from '../utils/helpers'
import GlobalStyle2 from '../styles/global'
import Header from '../components/Header/Header'

const FlexContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${({ theme }) => `${theme.spacings.spacing32} 0`};

  ${media.desktop`
    margin: ${({ theme }) => `${theme.spacings.spacing64} 0`};
  `}
`

const PlaceOfBusiness = ({ id, lang, name }) => {
  const data = useStaticQuery(graphql`
    query {
      ...Globals
    }
  `)

  setCurrentLanguage(lang)
  const { headerItems, footerItems, translations } = helpers.getProcessedData(data, lang)

  const translatedPaths = {
    FI: `/toimipaikka/${name}/${id}`,
    SV: `/sv/verksamhetsstalle/${name}/${id}`,
    EN: `/en/location/${name}/${id}`,
  }

  const pathsForAvailableLanguages = translations.order.reduce((paths, lang) => {
    paths[lang] = translatedPaths[lang]
    return paths
  }, {})

  // Replace the paths since these pages are not coming from WordPress and therefore are missing the information
  const pobTranslations = { ...translations, paths: pathsForAvailableLanguages }

  const endpoint = process.env.WP_URL
    ? `${process.env.WP_URL}/wp-json/v2`
    : `https://s-kanava.brand-sites.wp-test.s-cloud.fi/wp-json/v2`

  return (
    <Layout>
      <ThemeProvider theme={sKanava}>
        <GlobalStyle />
        <GlobalStyle2 />
        <SBonus.CSS />
        <SBonusDisplay.CSS />
        <Header menuItems={headerItems} translations={pobTranslations} />
        <RestrictedWidthContainer>
          <AnimationWrapper blockName="">
            <FlexContainer>
              <PlaceOfBusinessInfo endpoint={endpoint} laariId={id} lang={lang} />
            </FlexContainer>
          </AnimationWrapper>
        </RestrictedWidthContainer>
        <Footer links={footerItems} />
      </ThemeProvider>
    </Layout>
  )
}

export default PlaceOfBusiness
